const Generics = {
  Email: {
    type: "email",
    id: "email",
    name: "email",
    label: "Email",
    w: "35px",
    placeholder: "example@mail.com",
    validation: {
      required: "Email is required",
      pattern: {
        value:
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        message: "Please enter a valid email.",
      },
    },
  },

  URL: {
    type: "text",
    id: "url",
    name: "url",
    validation: {
      required: "Please enter link to organization website.",
      pattern: {
        value:
          /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
        message: "Please enter a valid link.",
      },
    },
    placeholder: "E.g https://drive.get-organization.com",
    label: "Website",
    className: "w-full",
    required: false,
  },

  FirstName: {
    type: "text",
    id: "firstName",
    name: "firstName",
    validation: {
      required: "Please enter first name.",
    },
    placeholder: "Susan",
    label: "First Name",
    containerClass: "flex-grow",
    required: false,
  },

  LastName: {
    type: "text",
    id: "firstName",
    name: "firstName",
    validation: {
      required: "Please enter last name.",
    },
    placeholder: "Markle",
    label: "Last Name",
    containerClass: "flex-grow",
    required: false,
  },
};

export default Generics;
